import { ImageAnnotation } from "@annotorious/react"
import { DettaglioImmagineTavola, DettaglioTavola } from "../types"
import { Geometry } from "@annotorious/annotorious"

export function hasCoords(dettaglio: DettaglioTavola | DettaglioImmagineTavola) {
    return (
        Number.isFinite(dettaglio.top) &&
        Number.isFinite(dettaglio.left) &&
        Number.isFinite(dettaglio.bottom) &&
        Number.isFinite(dettaglio.right)
    )
}

export function annotationToCoords(annotation: any) {
    const geometry = annotation?.target.selector.geometry
    if (!geometry) return null
    return {
        top: geometry.y,
        left: geometry.x,
        bottom: geometry.y + geometry.h,
        right: geometry.x + geometry.w,
    }
}

export function dettaglioTavolaToAnnotation(dettaglio: DettaglioTavola | DettaglioImmagineTavola, id?: number): any {
    if (!dettaglio) return null
    if (
        (dettaglio.top === undefined ||  dettaglio.top === null) ||
        (dettaglio.left === undefined ||  dettaglio.left === null) ||
        (dettaglio.bottom === undefined ||  dettaglio.bottom === null) ||
        (dettaglio.right === undefined ||  dettaglio.right === null)
    ) {
        return null
    }
    const selector = {
        type: "RECTANGLE",
        geometry: {
            x: dettaglio.left,
            y: dettaglio.top,
            w: dettaglio.right - dettaglio.left,
            h: dettaglio.bottom - dettaglio.top,
            bounds : {
                minX: dettaglio.left,
                minY: dettaglio.top,
                maxX: dettaglio.right,
                maxY: dettaglio.bottom,
            }
        },
    }  

    return {
        id: id?.toString() || dettaglio.id.toString(),
        target: { selector },
        properties: {
            id: id || dettaglio.id,
        }
    }


}